import {Validation} from "@/data/Validation";
import {ExternalFile} from "@/data/entities/storage";
import {JobOpeningPreview} from "@/data/entities/jobOpening";

export type JobApplicationStatus =
    | "OPEN"
    | "IN_PROGRESS"
    | "CLOSED";

export type JobApplicationInOverview = {
    id: number,
    jobOpening: JobOpeningPreview,
    firstName: string,
    lastName: string,
    status: JobApplicationStatus,
    creationDate: string,
};

export type JobApplicationDetails = {
    id: number,
    jobOpening: JobOpeningPreview,
    attachment: ExternalFile | null,
    firstName: string,
    lastName: string,
    emailAddress: string,
    phoneNumber: string,
    motivation: string,
    internalNote: string,
    status: JobApplicationStatus,
    creationDate: string,
};

export type UpdatedJobApplication = Pick<JobApplicationDetails, "status" | "internalNote">;

export const updatedJobApplicationFormValidation: Validation<UpdatedJobApplication> = {
    status: {
        required: true,
        minLength: 1,
        maxLength: 56,
    },
    internalNote: {
        required: true,
        min: 1,
        max: 4096,
    },
}
